import {
  Box,
  Container,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { GameDataModel } from './GameDataModel'
import { GameThumbnail } from './GameThumbnail'

export function GameSelector({
  games,
  selectedGameId,
  setSelectedGameId,
}: {
  games: GameDataModel[]
  selectedGameId: string
  setSelectedGameId: (gameId: string) => void
}) {
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))
  if (!isLargeScreen) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          rowGap: 2,
          flexBasis: 'auto',
          width: '100%',
          height: '100px',
          paddingTop: '100px',
        }}
      >
        {games.map((value) => (
          <Box key={value.id}>
            <ListItemButton
              disableGutters
              onClick={() => setSelectedGameId(value.id)}
              selected={value.id == selectedGameId}
              sx={{
                p: 0,
                ':hover': { paddingTop: 2 },
                transition: 'padding-top 0.3s',
                width: 48,
                height: 48,
              }}
            >
              <ListItemAvatar sx={{ mx: 0, p: 0 }}>
                <GameThumbnail
                  thumbnailImagePath={value.thumbnailImagePath}
                  thumbnailImageSize={48}
                />
              </ListItemAvatar>
            </ListItemButton>
          </Box>
        ))}
      </Box>
    )
  }
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        paddingLeft: 2,
        background: 'linear-gradient(to right, black, black 20%, transparent)',
      }}
    >
      <Box sx={{ flexGrow: 1 }} />
      {games.map((value) => (
        <Box key={value.id}>
          <ListItemButton
            disableGutters
            onClick={() => setSelectedGameId(value.id)}
            selected={value.id == selectedGameId}
            sx={{
              borderRadius: 4,
              ':hover': { paddingLeft: 1 },
              transition: 'padding-left 0.3s',
            }}
          >
            <ListItemAvatar>
              <GameThumbnail
                thumbnailImagePath={value.thumbnailImagePath}
                thumbnailImageSize={32}
              />
            </ListItemAvatar>
            <ListItemText
              primary={value.title}
              secondary={
                <Typography variant="caption" sx={{ opacity: 0.5 }}>
                  {value.subtitle}
                </Typography>
              }
              sx={{
                color: 'white',
              }}
            />
          </ListItemButton>
        </Box>
      ))}
      <Box sx={{ flexGrow: 1 }} />
    </Container>
  )
}
